export function getNameWithFilter(name, filter) {
  if (!filter || name.toLowerCase().indexOf(filter) === -1) return name;

  const reg = new RegExp(filter, 'gi');
  const newName = name.replace(reg, (match, offset, origin) => {
    const str = `<span style="background-color: #c7c7c7">${origin.substr(offset, filter.length)}</span>`;
    return str;
  });

  return newName;
}

export function setCookie(name, value, exdays) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  const cookieValue = escape(value) + ((exdays == null) ? '' : `; expires=${exdate.toUTCString()}`);
  document.cookie = `${name}=${cookieValue}`;
}

export function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setHash(id) {
  let url = window.location.origin + window.location.pathname;
  url += `#${id}`;
  window.location = url;
}

export const basePath = getBasePath();

function getBasePath () {
  const base = document.querySelector('head base');
  let path = './';
  if (base) path = base.href;
  
  return path;
}
